var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectionDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03466 0.390614C2.74088 -0.841087 4.3431 1.13158 5.07433 2.28204C6.7513 4.88194 8.36976 7.53383 9.94923 10.1857C12.775 15.6079 16.6646 20.4049 21.3857 24.2902C24.5965 18.3625 28.9901 13.157 34.2945 8.99628C37.2584 6.65312 40.6969 14.0661 38.0579 16.159C31.057 21.558 25.882 28.9757 23.2317 37.4099C22.3542 40.2861 19.3318 38.7489 18.3568 36.8152C13.0791 26.1024 7.19928 15.697 0.745422 5.64891C-0.10281 4.30671 -0.489555 1.48907 1.03466 0.390614Z",
    fill: "#FE7C1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionDown);
export default __webpack_public_path__ + "static/media/direction_down.1eb619189ce3469d4dc0e523b38c78b1.svg";
export { ForwardRef as ReactComponent };